import { AD_EFFECTIVE_STATUS, AD_STATUS } from '@/consts.js';
import AdService from '@/services/Ad.js';

export default {
  data: () => ({
    updatingAdStatusIds: [],
  }),
  methods: {
    // Either flag alone marks a deleted ad: deleted_at is the soft delete, while the status can arrive from Meta first.
    isAdDeleted(ad) {
      return !!ad.deleted_at || Number(ad.status) === AD_STATUS.DELETED;
    },
    // Meta reports rejection only in effective_status, the status keeps the configured value (e.g. ACTIVE).
    isAdRejected(ad) {
      return !this.isAdDeleted(ad) && Number(ad.effective_status) === AD_EFFECTIVE_STATUS.REJECTED;
    },
    // An ad only delivers while its campaign is active too.
    isAdActive(ad) {
      const campaignIsActive = !ad.campaign || Number(ad.campaign.status) === 1;

      return !this.isAdDeleted(ad)
        && Number(ad.effective_status) === AD_EFFECTIVE_STATUS.ACTIVE
        && campaignIsActive;
    },
    isAdStatusUpdating(ad) {
      return this.updatingAdStatusIds.includes(ad.id);
    },
    isAdSwitchDisabled(ad) {
      // Deleted and Meta-rejected ads cannot be delivered, so switching them is pointless.
      return this.isAdDeleted(ad)
        || this.isAdRejected(ad)
        || !this.$root.isLoggedIn
        || this.$root.loggedInUser?.level === 'restricted_viewer';
    },
    onChangeAdStatus(ad, newStatus) {
      if (this.isAdStatusUpdating(ad)) {
        return;
      }

      if (newStatus && ad.campaign?.deleted_at) {
        this.infoToast(this.tr('The ad cannot be activated because the campaign is deleted.'));
        return;
      }

      if (newStatus && Number(ad.campaign?.status) !== 1) {
        this.infoToast(this.tr('The ad cannot be activated because the campaign is not active. Please activate the campaign first.'));
        return;
      }

      this.updatingAdStatusIds.push(ad.id);

      AdService.updateStatus(ad.id, newStatus)
        .then(resp => ad.updateWith(resp))
        .catch(err => this.error(err))
        .finally(() => {
          this.updatingAdStatusIds = this.updatingAdStatusIds.filter(id => id !== ad.id);
        });
    },
  },
};
